import type { PdsIconName } from '@/components/pds/icons';

const TYPE_LABELS: Record<string, string> = {
  pos: 'Caisse',
  kiosk: 'Borne',
  pds: 'Écran de préparation',
  print_agent: 'Agent d’impression',
  printer: 'Imprimante',
  scale: 'Balance',
  payment_terminal: 'Terminal de paiement',
  wifi_bridge: 'Pont Wi-Fi',
  ip_scanner: 'Scanner IP',
  usb_scanner: 'Scanner USB',
  cash_drawer: 'Tiroir-caisse',
};

export const deviceTypeLabel = (type: string) => TYPE_LABELS[type] ?? type;

export const deviceIcon = (type: string, online: boolean): PdsIconName => {
  if (type === 'printer') return online ? 'printer' : 'printer-off';
  if (type === 'scale') return 'scale';
  if (type === 'payment_terminal') return 'card';
  return 'box';
};
